import { clamp, medianInPlace } from '@/core/util/math';

/** Clicks played during calibration; the first ones are lead-in and don't count. */
export const CALIBRATION_CLICKS = 10;
export const LEAD_IN_CLICKS = 2;
export const CLICK_INTERVAL = 0.6;
export const MAX_OFFSET_MS = 300;

/**
 * Visual offset from taps. Each tap is matched to the nearest click; the offset is how much
 * later than expected the listener hears it (tap time − click time − reported output latency),
 * as the median over the taps, so a few mistimed taps don't matter. Null with too few taps.
 */
export function offsetFromTaps(
  clickTimes: number[],
  tapTimes: number[],
  outputLatency: number,
): number | null {
  const counted = clickTimes.slice(LEAD_IN_CLICKS);
  const diffs: number[] = [];
  for (const tap of tapTimes) {
    let nearest = Infinity;
    for (const click of counted)
      if (Math.abs(tap - click) < Math.abs(nearest)) nearest = tap - click;
    if (Math.abs(nearest) <= CLICK_INTERVAL / 2) diffs.push(nearest - outputLatency);
  }
  if (diffs.length < 4) return null;
  return clamp(Math.round(medianInPlace(diffs) * 1000), -MAX_OFFSET_MS, MAX_OFFSET_MS);
}
